import { AuthContext } from '@repo-level/core-front';
import type { ICMSLottery } from 'api/cms/lottery';
import { useCallback, useContext } from 'react';
import { isLotteryForPlayer } from '../helpers/access';

export const useLotteryAccess = () => {
  const { user } = useContext(AuthContext);

  return useCallback(
    (cmsLottery: ICMSLottery) => isLotteryForPlayer(cmsLottery, user),
    [user]
  );
};
